import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import TestWhishListCard from "src/Components/WebsiteComponents/HomePage/Cards/TestWhishListCard";
import httpRequest from "src/helpers/httpRequest";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import NoItemUI from "src/Components/NoItemUI";
import { Loader } from "lucide-react";
import NoItemImg from "src/assets/images/not-data/no-labtest.png";
import { useNavigate } from "react-router-dom";
import InfinteScrollWrapper from "src/Components/GlobalComponents/Widget/InfinteScrollWrapper";

interface IObj {
  _id: string;
  name: string;
  description: string;
  image: string;
  isLiked: boolean;
  regularPrice: number;
  salePrice: number | null;
  prescriptionRequired: boolean;
  testType: string;
  noOfBiomarkers: number;
}

interface IResponse {
  documents: IObj[];
  paginated: IPaginated;
}

const tests = [
  {
    id: 1,
    name: "Life Platinum Package",
    description: "Blood Test",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    tests: 13,
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 2,
    name: "Life Platinum Package",
    description: "Blood Test",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    tests: 13,
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 3,
    name: "Life Platinum Package",
    description: "Blood Test",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    tests: 13,
    regularPrice: 1000,
    salePrice: 800,
  },
];

const TestsWhishList = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<{
    page: number;
    limit: number;
    bool: boolean;
  }>({
    page: 1,
    limit: 10,
    bool: false,
  });

  const handleRemove = (obj: { productId: string }) => {
    if (data?.length > 1) {
      setData((prev) => prev?.filter((v) => v._id !== obj?.productId));
    } else {
      handleQueryParamsChange({
        page: queryParams?.page > 1 ? queryParams?.page - 1 : queryParams?.page,
      });
    }
  };

  const fetch = async (params: Partial<typeof queryParams>) => {
    setIsLoader(true);
    const { bool, ...actulaParams } = params;
    const { res, err } = await httpRequest<IResponse>({
      path: `/product/fav?${qs.stringify(actulaParams)}`,
    });
    if (res) {
      setData((prev) => [...prev, ...res?.documents]);
      setPaginated(res?.paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleQueryParamsChange = (
    params: Partial<typeof queryParams>,
    reset = true
  ) => {
    let updatedParams = { ...queryParams, ...params };
    setQueryParams(updatedParams);
    if (reset) {
      setPaginated({
        currentPage: 1,
        totalPages: 1,
      });
      updatedParams.page = 1;
      setData([]);
    }
    fetch(updatedParams);
  };
  useEffect(() => {
    handleQueryParamsChange(queryParams);
  }, []);

  return (
    <>
      {/* {isLoader ? (
        <div className="flex justify-center items-center h-full gap-2 min-h-[130px]">
          <Loader className="animate-spin" />
          <p className="font-Poppins-Regular font-size-14px text-[#333333]">
            Loading Favorite Tests...
          </p>
        </div>
      ) : data.length === 0 ? (
        <div className="w-full mt-5">
          <NoItemUI
            text="No Tests Found"
            text2="Your test wishlist is empty. Explore and save tests for quick access."
            iconImagePath={NoItemImg}
            onButtonClick={() => {
              onClose();
              navigate("/diagnostic-products");
            }}
            ButtonText="Discover Tests"
          />
        </div>
      ) : (
        data.map((test, index) => (
          <TestWhishListCard
            key={test._id}
            data={test}
            heart_id={`heart-${index}`}
            button_id={`button-${index}`}
            handleRemove={() => handleRemove({ productId: test._id })}
          />
        ))
      )} */}
      <InfinteScrollWrapper
        isLoading={isLoader}
        length={data?.length}
        currentPage={queryParams?.page}
        totalPages={paginated?.totalPages}
        onLoadMore={(page) => {
          handleQueryParamsChange({ page: page }, false);
        }}
        calculateHeight
        noDataOptions={{
          text: "No Tests Found",
          text2:
            "Your test wishlist is empty. Explore and save tests for quick access.",
          iconImagePath: NoItemImg,
          buttonOnPress: () => {
            onClose();
            navigate("/diagnostic-products");
          },
          buttonText: "Discover Tests",
        }}
        itemClassName=".tab-slider-container-main"
      >
        {data.map((test, index) => (
          <TestWhishListCard
            key={test._id}
            data={test}
            heart_id={`heart-${index}`}
            button_id={`button-${index}`}
            handleRemove={() => handleRemove({ productId: test._id })}
          />
        ))}
      </InfinteScrollWrapper>
    </>
  );
};

export default TestsWhishList;
